// extracted by mini-css-extract-plugin
module.exports = {"content":"logout_content__JN_Ny","buttons":"logout_buttons__mmvqg"};